


























































import { Component, Prop } from 'vue-property-decorator';
import { GuardileoVueComponent } from '@/lib';
import { PageStore, PageStores } from "@/store/modules/page-store";
import { DrittlandtransferpruefungApi, Drittlandtransferpruefung_base_info, Drittlandtransferpruefung_info } from './api-dltp';

import { tabs } from './tabs-dltp';

@Component({})
export default class extends GuardileoVueComponent {
    private api!: DrittlandtransferpruefungApi;
    private pageStore: PageStore = PageStores.datenschutzFa;

    private tabs = tabs;

    @Prop() private readonly!: boolean;
    private id: number = 0;

    //private data: Drittlandtransferpruefung_base_info | null = null;
    private data: string | null = null;

    async created() {
        window.addEventListener('scroll', this.handleScroll);
    }

    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(a:any) {
        if (window.scrollY > 8) {
            (this.$refs.scrollEl as HTMLElement).setAttribute("style", "padding-top: 8px;");
        } else {
            (this.$refs.scrollEl as HTMLElement).setAttribute("style", "padding-top: 00px;");
        }
    }

    async mounted() {
        this.id = (<any>this.$route.params).id;
        this.api = new DrittlandtransferpruefungApi();
        await this.reload();
    }

    async reload() {
        this.data = await this.guard_status(async () => await this.api.Name(this.id));
    }

    get darf_bearbeiten(): boolean {
        return (!this.readonly && !this.status_loading && !this.status_failed
            && this.hat_Berechtigung('Verarbeitungstaetigkeiten_bearbeiten'));
    }
}
